import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import ExportCSVChart from './export/Export';
import { NODE_STATES } from './utils';
import NodesModal from './table/nodesModal';
import { getChartNodes } from '../../store/fuse/dashboard';

const { VictoryChart, VictoryTheme, VictoryAxis, VictoryBar, VictoryStack, VictoryLegend, Bar, VictoryLabel } = require('victory');

const BarCharColors = {
  up: '#71DC83',
  warning: '#ED6C02',
  down: '#E50101',
  unmanaged: '#27C8E2',
};

const CustomTickLabel = (props) => {
  let tickText = props.text;
  const { textColor } = props;
  tickText = tickText.replace('Inmueble con', '');
  tickText = tickText.replace('Consumo', '');
  const maxCharsPerLine = 19;

  const lines = [];
  for (let i = 0; i < tickText.length; i += maxCharsPerLine) {
    lines.push(tickText.slice(i, i + maxCharsPerLine));
  }
  const xV = props.x - 60;
  const xY = lines.length === 1 ? props.y : props.y - 10;

  return (
    <g transform={`translate(${xV}, ${xY})`}>
      {lines.map((line, index) => (
        <text key={index} x={0} y={index * 16} textAnchor="middle" fill={textColor}>
          {line}
        </text>
      ))}
    </g>
  );
};

const CustomTickLabelY = (props) => {
  const { text, textColor } = props;
  return (
    <g transform={`translate(${props.x}, ${props.y})`}>
      <text x={0} y={0} textAnchor="end" fill={textColor}>
        {Number(text).toFixed(1)}
      </text>
    </g>
  );
};

function Barraschart(props) {
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalChart, setOpenModalChart] = React.useState(false);
  const [renderGreen, setRenderGreen] = React.useState(false);
  const [renderYellow, setRenderYellow] = React.useState(true);
  const [renderRed, setRenderRed] = React.useState(true);
  const [renderGray, setRenderGray] = React.useState(false);

  const [textColor, setTextColor] = React.useState('#000000');

  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.fuse?.dashboard?.loadingChartNodes);
  const nodesData = useSelector((state) => state?.fuse?.dashboard?.dashboard?.chartNodes);
  const filtersSelected = useSelector((state) => state?.fuse?.dashboard?.dashboard?.filters?.filtersSelected);

  const tipoInmueblesData = useSelector((state) => state.fuse?.dashboard?.dashboard?.charts?.tipoInmuebles);
  const grupoInmueblesData = useSelector((state) => state.fuse?.dashboard?.dashboard?.charts?.gruposInmueble);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  useEffect(() => {
    setTextColor(darkMode ? '#FFFFFF' : '#000000');
  }, [darkMode]);

  const fillStyle = {
    fill: darkMode ? '#FFFFFF' : '#000000'
  };

  const handleOpenModal = (data, color) => {
    if ('tipoinmuebleid' in data) {
      dispatch(getChartNodes({ value: data.tipoinmuebleid, category: 'inmueble', color, filters: filtersSelected }));
    } else {
      dispatch(getChartNodes({ value: data.grupoinmuebleid, category: 'grupo', color, filters: filtersSelected }));
    }
    setOpenModal(true);
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleBarLabel = (data, color) => {
    let value = '';
    if (color === 'verde') {
      // Green bar is the only one active
      if (renderGreen && !renderRed && !renderYellow && !renderGray) {
        value = data.verde;
      }
    }
    if (color === 'amarillo') {
      // Green, yellow bars are active and red, gray bars are inactive
      if (renderGreen && !renderRed && renderYellow && !renderGray) {
        value = Number(data.verde) + Number(data.amarillo);
      }
      // Yellow bar is the only one active
      if (!renderGreen && !renderRed && renderYellow && !renderGray) {
        value = data.amarillo;
      }
    }
    if (color === 'rojo') {
      // Green, yellow, red bar are active and grey bar is inactive
      if (renderGreen && renderRed && renderYellow && !renderGray) {
        value = Number(data.verde) + Number(data.amarillo) + Number(data.rojo);
      }
      // Yellow, red bar are active and green, grey bar are inactive
      if (!renderGreen && renderRed && renderYellow && !renderGray) {
        value = Number(data.amarillo) + Number(data.rojo);
      }
      // Gren, red bar are active and Yellow, grey bar are inactive
      if (renderGreen && renderRed && !renderYellow && !renderGray) {
        value = Number(data.verde) + Number(data.rojo);
      }
      // Only red bar is active
      if (!renderGreen && renderRed && !renderYellow && !renderGray) {
        value = data.rojo;
      }
    }
    return value;
  };

  const setChartData = () => {
    if (props?.title === 'Grupos de Inmuebles') {
      if (grupoInmueblesData.length === 0) {
        return props?.initialData;
      }
      return grupoInmueblesData;
    }
    if (tipoInmueblesData.length === 0) {
      return props?.initialData;
    }
    return tipoInmueblesData;
  };

  const handleOpenModalChart = () => {
    setOpenModalChart(true);
  };

  const handleCloseModalChart = () => {
    setOpenModalChart(false);
  };

  return (
    <>
      <div className="w-60 mt-10 flex-grow">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong className="title-chart">{props.title}</strong>
          <div>
            <IconButton aria-label="download-chart" size="medium">
              <ExportCSVChart
                fileName={`${props.title}`}
                data={props?.title === 'Grupos de Inmuebles' ? grupoInmueblesData : tipoInmueblesData}
              />
            </IconButton>
            <IconButton aria-label="fullscreen" size="medium" onClick={handleOpenModalChart}>
              <FullscreenIcon />
            </IconButton>
          </div>
        </div>
        <div className="flex flex-row justify-center">
          <div className="mt-9 mr-9 ml-9" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <div
              role="button"
              aria-label="green-bar-rendering-btn"
              className="bar-chart-color-section"
              onClick={() => setRenderGreen(!renderGreen)}
              onKeyDown={() => setRenderGreen(!renderGreen)}
              tabIndex={0}
              style={{ background: renderGreen ? NODE_STATES[2] : NODE_STATES[4] }}
            />
            <h4>Verde</h4>
          </div>
          <div className="mt-9 mr-9 ml-9" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <div
              role="button"
              aria-label="yellow-bar-rendering-btn"
              className="bar-chart-color-section"
              onClick={() => setRenderYellow(!renderYellow)}
              onKeyDown={() => setRenderYellow(!renderYellow)}
              tabIndex={0}
              style={{ background: renderYellow ? NODE_STATES[1] : NODE_STATES[4] }}
            />
            <h4>Amarillo</h4>
          </div>
          <div className="mt-9 mr-9 ml-9" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <div
              role="button"
              aria-label="red-bar-rendering-btn"
              className="bar-chart-color-section"
              onClick={() => setRenderRed(!renderRed)}
              onKeyDown={() => setRenderRed(!renderRed)}
              tabIndex={0}
              style={{ background: renderRed ? NODE_STATES[0] : NODE_STATES[4] }}
            />
            <h4>Rojo</h4>
          </div>
        </div>
        <VictoryChart
          theme={VictoryTheme.material}
          width={550}
          height={550}
          padding={{ top: 20, bottom: 100, left: 100 }}
          domainPadding={40}
        >
          <VictoryAxis
            tickLabelComponent={<CustomTickLabel textColor={textColor} />}
            style={{
              ticks: { stroke: 'none' },
              grid: { stroke: 'none' },
            }}
          />
          <VictoryAxis
            dependentAxis
            tickLabelComponent={<CustomTickLabelY textColor={textColor} />}
            style={{
              ticks: { stroke: 'none' }, // Hide the ticks,
              grid: { stroke: 'none' },
            }}
          />
          <VictoryStack>
            {renderGreen && (
              <VictoryBar
                horizontal
                barWidth={20}
                style={{ data: { fill: NODE_STATES[2], cursor: 'pointer' } }}
                data={setChartData()}
                x={props.axisXKey}
                y="verde"
                labels={({ datum }) => `${datum?.verde}`}
                // labelComponent={<CustomLabel color="verde" />}
                labelComponent={
                  <VictoryLabel style={fillStyle} text={({ datum }) => handleBarLabel(datum, 'verde')} />
                }
                events={[
                  {
                    target: 'data',
                    eventHandlers: {
                      onClick: (evt, data) => {
                        handleOpenModal(data.datum, 'verde');
                      },
                    },
                  },
                ]}
              />
            )}
            {renderYellow && (
              <VictoryBar
                barWidth={20}
                style={{ data: { fill: NODE_STATES[1], cursor: 'pointer' } }}
                horizontal
                data={setChartData()}
                x={props.axisXKey}
                y="amarillo"
                labels={({ datum }) => `${datum?.amarillo}`}
                // labelComponent={<CustomLabel color="amarillo" />}
                labelComponent={
                  <VictoryLabel
                    style={fillStyle}
                    text={({ datum }) => handleBarLabel(datum, 'amarillo')}
                  />
                }
                events={[
                  {
                    target: 'data',
                    eventHandlers: {
                      onClick: (evt, data) => {
                        handleOpenModal(data.datum, 'amarillo');
                      },
                    },
                  },
                ]}
              />
            )}
            {renderRed && (
              <VictoryBar
                horizontal
                barWidth={20}
                style={{ data: { fill: NODE_STATES[0], cursor: 'pointer' } }}
                data={setChartData()}
                x={props.axisXKey}
                y="rojo"
                labels={({ datum }) => `${datum?.rojo}`}
                labelComponent={
                  <VictoryLabel style={fillStyle} text={({ datum }) => handleBarLabel(datum, 'rojo')} />
                }
                // labelComponent={<CustomLabel color="rojo" />}
                events={[
                  {
                    target: 'data',
                    eventHandlers: {
                      onClick: (evt, data) => {
                        handleOpenModal(data.datum, 'rojo');
                      },
                    },
                  },
                ]}
              />
            )}
          </VictoryStack>
        </VictoryChart>
      </div>
      <NodesModal openModal={openModal} handleCloseModal={handleCloseModal} loading={loading} nodesData={nodesData} />
      <Dialog open={openModalChart} onClose={handleCloseModal} fullWidth fullScreen>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong className="title-chart">{props.title}</strong>
            <div>
              <IconButton aria-label="download-chart" size="medium">
                <ExportCSVChart
                  fileName={`${props.title}`}
                  data={props?.title === 'Grupos de Inmuebles' ? grupoInmueblesData : tipoInmueblesData}
                />
              </IconButton>
              <IconButton aria-label="fullscreen" size="medium" onClick={handleCloseModalChart}>
                <FullscreenExitIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="flex flex-row justify-center">
            <div
              className="mt-9 mr-9 ml-9"
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
            >
              <div
                role="button"
                aria-label="green-bar-rendering-btn"
                className="bar-chart-color-section"
                onClick={() => setRenderGreen(!renderGreen)}
                onKeyDown={() => setRenderGreen(!renderGreen)}
                tabIndex={0}
                style={{ background: renderGreen ? NODE_STATES[2] : NODE_STATES[4] }}
              />
              <h4>Verde</h4>
            </div>
            <div
              className="mt-9 mr-9 ml-9"
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
            >
              <div
                role="button"
                aria-label="yellow-bar-rendering-btn"
                className="bar-chart-color-section"
                onClick={() => setRenderYellow(!renderYellow)}
                onKeyDown={() => setRenderYellow(!renderYellow)}
                tabIndex={0}
                style={{ background: renderYellow ? NODE_STATES[1] : NODE_STATES[4] }}
              />
              <h4>Amarillo</h4>
            </div>
            <div
              className="mt-9 mr-9 ml-9"
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
            >
              <div
                role="button"
                aria-label="red-bar-rendering-btn"
                className="bar-chart-color-section"
                onClick={() => setRenderRed(!renderRed)}
                onKeyDown={() => setRenderRed(!renderRed)}
                tabIndex={0}
                style={{ background: renderRed ? NODE_STATES[0] : NODE_STATES[4] }}
              />
              <h4>Rojo</h4>
            </div>
          </div>
          <VictoryChart
            theme={VictoryTheme.material}
            width={550}
            height={550}
            padding={{ top: 20, bottom: 100, right: 50, left: 50 }}
            domainPadding={40}
          >
            <VictoryAxis
              tickLabelComponent={<CustomTickLabel textColor={textColor} />}
              style={{
                ticks: { stroke: 'none' }, // Hide the ticks
                grid: { stroke: 'none' },
              }}
            />
            <VictoryAxis
              dependentAxis
              tickLabelComponent={<CustomTickLabelY textColor={textColor} />}
              style={{
                ticks: { stroke: 'none' }, // Hide the ticks,
                grid: { stroke: 'none' },
              }}
            />
            <VictoryStack>
              {renderGreen && (
                <VictoryBar
                  horizontal
                  barWidth={20}
                  style={{ data: { fill: NODE_STATES[2], cursor: 'pointer' } }}
                  data={setChartData()}
                  x={props.axisXKey}
                  y="verde"
                  labels={({ datum }) => `${datum?.verde}`}
                  // labelComponent={<CustomLabel color="verde" />}
                  labelComponent={
                    <VictoryLabel style={fillStyle} text={({ datum }) => handleBarLabel(datum, 'verde')} />
                  }
                  events={[
                    {
                      target: 'data',
                      eventHandlers: {
                        onClick: (evt, data) => {
                          handleOpenModal(data.datum, 'verde');
                        },
                      },
                    },
                  ]}
                />
              )}
              {renderYellow && (
                <VictoryBar
                  barWidth={20}
                  style={{ data: { fill: NODE_STATES[1], cursor: 'pointer' } }}
                  horizontal
                  data={setChartData()}
                  x={props.axisXKey}
                  y="amarillo"
                  labels={({ datum }) => `${datum?.amarillo}`}
                  // labelComponent={<CustomLabel color="amarillo" />}
                  labelComponent={
                    <VictoryLabel
                      style={fillStyle}
                      text={({ datum }) => handleBarLabel(datum, 'amarillo')}
                    />
                  }
                  events={[
                    {
                      target: 'data',
                      eventHandlers: {
                        onClick: (evt, data) => {
                          handleOpenModal(data.datum, 'amarillo');
                        },
                      },
                    },
                  ]}
                />
              )}
              {renderRed && (
                <VictoryBar
                  horizontal
                  barWidth={20}
                  style={{ data: { fill: NODE_STATES[0], cursor: 'pointer' } }}
                  data={setChartData()}
                  x={props.axisXKey}
                  y="rojo"
                  labels={({ datum }) => `${datum?.rojo}`}
                  labelComponent={
                    <VictoryLabel style={fillStyle} text={({ datum }) => handleBarLabel(datum, 'rojo')} />
                  }
                  // labelComponent={<CustomLabel color="rojo" />}
                  events={[
                    {
                      target: 'data',
                      eventHandlers: {
                        onClick: (evt, data) => {
                          handleOpenModal(data.datum, 'rojo');
                        },
                      },
                    },
                  ]}
                />
              )}
            </VictoryStack>
          </VictoryChart>
        </DialogContent>
      </Dialog>
    </>
  );
}
export default Barraschart;
